import { nanoid } from "nanoid";
import Configs from "../config";
export const CURRENT_VERSION = "v1.0.138patch2";
export const CURRENT_VERSION_DATE = "9/14/2023 @ 6:00pm";

console.log(`Current version ${CURRENT_VERSION}`);

export async function checkCurrentVersion() {
  let response = await fetch(`${Configs.SERVER_URL}/version`);
  let responseJSON = await response.json();

  if (response.ok && responseJSON?.version !== CURRENT_VERSION) {
    let href = window.location.href;

    if (href.includes("?eraseCache=")) href = href.split("?eraseCache=")[0];

    //@ts-ignore
    window.location = href + `?eraseCache=${nanoid()}`;
  }
}
